import type { MessageKey } from '../../i18n/messages.en.ts';

/**
 * MVP-335. `GuestSearch.tsx`'s results list is the results region most likely to be read by a
 * screen reader in this app — a guest types, the list replaces itself, and (before this task)
 * nothing said so. This is the pure "what does the live region say" half of that fix, split out so
 * the one-vs-many branch (the shape `libraryActions.ts`'s `describeBreakMusicAction` already
 * settled on for this exact class of bug — see its own comment) has a test that does not need a
 * DOM.
 *
 * Returns `null` for the two states that must NOT re-announce a count: an error already speaks for
 * itself via `InlineAlert`'s own `role="alert"`, and the initial skeleton (`aria-hidden`) has no
 * count yet to report.
 */
export function guestResultsAnnouncement(
  songCount: number,
  status: { loading: boolean; hasError: boolean }
): { key: MessageKey; params?: { count: number } } | null {
  if (status.hasError) return null;
  if (status.loading && songCount === 0) return null;
  if (songCount === 0) return { key: 'guest.search.resultsAnnouncementNone' };
  if (songCount === 1) return { key: 'guest.search.resultsAnnouncementOneFound' };
  return { key: 'guest.search.resultsAnnouncementManyFound', params: { count: songCount } };
}
